import { Routes } from '@angular/router';
import { CONSTANTS } from 'app/constants';
import { AdminDrawingEuroPage } from 'app/pages/admin/drawings/euro-cups';
import { DrawingEuroSuperCupPage } from 'app/pages/admin/drawings/euro-super-cup';
import { DrawingNationalCupsPage } from 'app/pages/admin/drawings/national-cups/national-cups.page';
import { DrawingNationalSuperCupsPage } from 'app/pages/admin/drawings/national-super-cups';
import { SecondTourPage } from 'app/pages/admin/drawings/second-tour';
import { SecondTour12Page } from 'app/pages/admin/drawings/second-tour-12';
import { AdminDashboardPage, AdminJobLogsPage, AdminMatchDayListPage, AdminUsersListPage } from '../pages/admin';
import { SecurityGuard } from '../services';
import { AdminMaintenancePage } from 'app/pages/admin/maintenance';
import { WCFinalPage } from 'app/pages/admin/drawings/wc-final';
import { WCPlayOffPage } from 'app/pages/admin/drawings/wc-playoff';
import { WCQualificationPage } from 'app/pages/admin/drawings/wc-qualification';
import { AdminDrawingCarousel, AdminDrawingClubWorldCupGroup, AdminDrawingClubWorldCupPlayoff } from 'app/pages/admin/drawings';

export const ADMIN_ROUTES: Routes = [
  { 
    path: 'admin',
    component: AdminDashboardPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  { 
    path: 'admin/dashboard',
    component: AdminDashboardPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  { 
    path: 'admin/users',
    component: AdminUsersListPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  { 
    path: 'admin/match-days',
    component: AdminMatchDayListPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  { 
    path: 'admin/drawings/euro',
    component: AdminDrawingEuroPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/drawings/second-tour-16',
    component: SecondTourPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/drawings/second-tour-12',
    component: SecondTour12Page,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/drawings/national-cups',
    component: DrawingNationalCupsPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/drawings/national-super-cups',
    component: DrawingNationalSuperCupsPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/drawings/euro-super-cup',
    component: DrawingEuroSuperCupPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/drawings/wc-final',
    component: WCFinalPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/drawings/qualification',
    component: WCQualificationPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/drawings/wc-playoff',
    component: WCPlayOffPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/drawings/club-wc-group',
    component: AdminDrawingClubWorldCupGroup,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/drawings/club-wc-playoff',
    component: AdminDrawingClubWorldCupPlayoff,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/job-logs',
    component: AdminJobLogsPage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
  {
    path: 'admin/maintenance',
    component: AdminMaintenancePage,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
   {
    path: 'admin/drawings/carousel',
    component: AdminDrawingCarousel,
    canActivate: [SecurityGuard],
    data: { role: CONSTANTS.userRoles.admin }
  },
];